"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfosHeaderValues = exports.UserOnboardingStatus = void 0;
// Order is important for steps validation in trader service
var UserOnboardingStatus;
(function (UserOnboardingStatus) {
    UserOnboardingStatus["USER_INFOS"] = "user_infos";
    UserOnboardingStatus["COMPANY_INFOS"] = "company_infos";
    UserOnboardingStatus["JOB_AREA"] = "job_area";
    UserOnboardingStatus["JOB_SKILLS"] = "job_skills";
    UserOnboardingStatus["JOB_EQUIPMENT"] = "job_equipment";
    UserOnboardingStatus["DOCUMENTS_SUBMISSION"] = "documents_submission";
    UserOnboardingStatus["DONE"] = "done";
})(UserOnboardingStatus = exports.UserOnboardingStatus || (exports.UserOnboardingStatus = {}));
var InfosHeaderValues;
(function (InfosHeaderValues) {
    InfosHeaderValues["TRADER_APP"] = "trader_app";
})(InfosHeaderValues = exports.InfosHeaderValues || (exports.InfosHeaderValues = {}));
//# sourceMappingURL=user.js.map